import { ModelRoutes, ModelApiService } from "services/strapi"
import { IConcierge } from "features/concierges"

class ConciergeApiSingleton extends ModelApiService<IConcierge> {}

export const conciergeApi = new ConciergeApiSingleton(ModelRoutes.Concierges)
